import { Suspense, useMemo } from "react";
import { baseUrl, entrySearchResultService, fetchKmsData } from "@kaltura/mediaspace-shared-utils";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import SearchResultsSkeleton from "./SearchResultsSkeleton";
import { KalturaESearchEntryResult } from "kaltura-typescript-client/api/types/KalturaESearchEntryResult";
import SearchResultsInnerContainer from "./SearchResultsInnerContainer";
import { FilterValues } from "@kaltura/mediaspace-shared-types";
import { SearchResultsProps } from "./SearchResults";

export interface SearchResultsContainerProps {
    /**
     * id of current search-result entry
     */
    entryId: string;

    /**
     * filters used to get this search-result
     */
    filterValues: FilterValues;

    /**
     * general API search result with possibly partial data
     */
    searchResult: KalturaESearchEntryResult;

    className?: string;

    /**
     * if true, only show base info, even when isSearch
     */
    showBaseInfoOnly: boolean;
}

/**
 * explore search-result reasons Suspense container
 */
export function SearchResultsContainer(props: SearchResultsContainerProps) {
    const { entryId, searchResult, filterValues, className, showBaseInfoOnly } = props;

    // fetch data from kms
    const fetchMetadata = useMemo(() => {
        if (entrySearchResultService.isFullResult(searchResult)) {
            // if we have all info, pass it on
            return () => {
                return {
                    searchResult: searchResult,
                };
            };
        }
        // if missing info, go to server.
        return fetchKmsData<SearchResultsProps>(baseUrl + "/global-search/explore-results/id/" + entryId, filterValues);
    }, [entryId, searchResult, filterValues]);

    // render with Suspense
    return (
        <ErrorBoundary fallback={<SearchResultsSkeleton />}>
            <div className={className}>
                <Suspense fallback={<SearchResultsSkeleton />}>
                    <SearchResultsInnerContainer
                        fetchMetadata={fetchMetadata}
                        showSearchResults={!!filterValues?.keyword && !showBaseInfoOnly}
                    ></SearchResultsInnerContainer>
                </Suspense>
            </div>
        </ErrorBoundary>
    );
}

export default SearchResultsContainer;
